// @ts-strict-ignore
import React from 'react'
import SocialSharing from '../trustyle-social-sharing'
import { canonicalHref } from '../helpers/meta-tags'
import { contentId, pageTitle } from '@uswitch/ev-utils/contentful'
import { Container } from '@uswitch/ev-core/react'
import { useDataSelector, useEntity, useMeta } from '@uswitch/ev-utils/context/selectors'
import { ConditionalWrapper } from '@uswitch/ev-utils/conditional-wrapper'

const SocialSharingCompound = ({ urlModule, includes, wrap = true }) => {
  const address = canonicalHref(urlModule)
  const linkedPageId = contentId(urlModule.link)
  const linkedPage = useEntity(linkedPageId)
  const titleContent = pageTitle(linkedPage)
  const twitterAccount = useMeta('twitterAccount')
  const twitterMsg = twitterAccount ? `${address} via ${twitterAccount}` : ''

  return (
    <ConditionalWrapper
      condition={wrap}
      wrapper={Container}
      sx={{ variant: 'compounds.social-sharing.outer-container' }}
    >
      <SocialSharing shareUrl={address} twitterMessage={twitterMsg} mailSubject={titleContent} />
    </ConditionalWrapper>
  )
}

const SocialSharingConnected = (props) => {
  const data = useDataSelector()
  const connectedProps = {
    urlModule: { ...data.url, ...data.rootEntity.fields },
    includes: data.includes,
  }
  return <SocialSharingCompound {...props} {...connectedProps} />
}

export default SocialSharingConnected
